export const baseURL = process.env.REACT_APP_BASE_URL;
export const urlimage = process.env.REACT_APP_URL_IMAGE;

